export default __webpack_public_path__ + "imgs/index.3600c11.jpg";